export default __webpack_public_path__ + "static/Van-Angled-Person-Arrow-c915da2a886419ca430023261754351d.png";